<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8 9.30001V5.70002C13.8 4.20883 12.5912 3 11.1 3L7.5 11.1V21H17.958C18.8555 21.0102 19.6235 20.3575 19.758 19.47L21 11.37C21.0792 10.8479 20.9252 10.3173 20.5787 9.91876C20.2322 9.52026 19.7281 9.29401 19.2 9.30001H13.8Z"
      stroke="#696D69"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 11.0003H5.097C4.04266 10.9816 3.14135 11.855 3 12.8999V19.1999C3.14135 20.2449 4.04266 21.0186 5.097 20.9999H7.5V11.0003Z"
      fill="#696D69"
      stroke="#696D69"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>
